"use client";

import { useEffect } from "react";
import "@/app/shipping-info/shipping.css";

export default function ShippingMap({ dark = false }) {
  useEffect(() => {
    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = src;
        s.async = false;
        s.onload = resolve;
        s.onerror = reject;
        document.body.appendChild(s);
      });

    let ro;

    (async () => {
      try {
        await loadScript(dark ? "/js/mapdata-dark.js" : "/js/mapdata.js");
        await loadScript("/js/usmap.js");

        const mapContainer = document.getElementById("map");
        if (mapContainer && mapContainer.getBoundingClientRect().height < 200) {
          mapContainer.style.minHeight = "500px";
        }

        setTimeout(() => {
          if (window.simplemaps_usmap?.resize) {
            window.simplemaps_usmap.resize();
          } else {
            window.dispatchEvent(new Event("resize"));
          }
        }, 400);

        const target = mapContainer?.parentElement || mapContainer;
        if (target && "ResizeObserver" in window) {
          ro = new ResizeObserver(() => {
            try { window.simplemaps_usmap?.resize?.(); } catch { }
          });
          ro.observe(target);
        }
      } catch (err) {
        console.error("Error loading map scripts:", err);
      }
    })();

    return () => { ro?.disconnect?.(); };
  }, []);

  const darkStyles = dark
    ? { background: "transparent", border: "none", boxShadow: "none" }
    : {};

  return (
    <div className="map-wrapper w-full" style={darkStyles}>
      <div
        id="map"
        className="w-full"
        style={dark ? { backgroundColor: "transparent", minHeight: "0" } : {}}
      />
    </div>
  );
}
